import React from 'react';

import { Loading } from 'components/Loading';
import { StyledLoadingWrapper } from './styled';

const loadingElement = (
  <StyledLoadingWrapper>
    <Loading size={50} />
  </StyledLoadingWrapper>
);
const containerElement = <div style={{ height: `100%`, position: 'relative' }} />;
const mapElement = <div style={{ height: `100%` }} />;

export { loadingElement, containerElement, mapElement };
